import Phaser from 'phaser';
import { gameState } from '../game.js';
import { UIManager } from '../managers/UIManager.js';

export class TitleScene extends Phaser.Scene {
    constructor() {
        super({ key: 'TitleScene' });
        
        // UIコンポーネント
        this.startButton = null;
        this.bgmButton = null;
        this.settingButton = null;
        this.titleText = null;
        
        // プレイヤー名関連
        this.playerNameText = null;
        this.editIcon = null;
        
        // 背景
        this.brickBackground = null;
        
        // UIマネージャー
        this.uiManager = null;
    }

    create() {
        console.log('TitleScene: Create function called');
        
        // UIマネージャーの初期化
        this.uiManager = new UIManager(this);
        
        // デスクトップの場合のみカーソルをポインタに
        if (!this.game.device.input.touch) {
            this.input.setDefaultCursor('pointer');
        }
        
        // 背景色の設定
        this.cameras.main.setBackgroundColor('#87CEEB');
        
        // レンガの背景を作成
        this.createBrickBackground();
        
        // タイトルテキスト
        this.createTitleText();
        
        // プレイヤー名表示
        this.createPlayerNameDisplay();
        
        // スタートボタン
        this.createStartButton();
        
        // BGMボタン
        this.createBgmButton();
        
        // ランキングボタン
        this.createRankingButton();
        
        // ABOUTボタン
        this.createAboutButton();
        
        // 設定ボタン
        this.createSettingButton();
        
        // リビジョン情報の表示
        this.uiManager.createRevisionText();
        
        console.log('TitleScene: Create function completed');
    }
    
    /**
     * プレイヤー名表示を作成する
     */
    createPlayerNameDisplay() {
        // プレイヤー名の表示（タイトルの下に配置）
        this.playerNameText = this.add.text(
            this.game.config.width / 2,
            this.game.config.height / 6 + 80, // タイトルの下に配置
            gameState.playerName,
            {
                fontSize: '32px',
                fontFamily: 'DotGothic16',
                fill: '#ffffff',
                stroke: '#000000',
                strokeThickness: 4
            }
        );
        this.playerNameText.setOrigin(0.5);
        
        // 編集アイコン
        this.editIcon = this.add.text(
            this.playerNameText.x + this.playerNameText.width / 2 + 20,
            this.playerNameText.y,
            '✏️',
            { fontSize: '28px' }
        );
        this.editIcon.setOrigin(0, 0.5);
        
        // インタラクティブに設定
        this.playerNameText.setInteractive();
        this.editIcon.setInteractive();
        
        // クリック/タップイベント
        const editName = () => {
            // ブラウザのpromptを使用して名前を入力
            const newName = prompt('Enter your player name (max 15 characters):', gameState.playerName);
            
            // キャンセルの場合は何もしない
            if (newName === null) {
                return;
            }
            
            // 空文字や空白のみの場合はデフォルト名に戻す
            if (newName.trim() === '') {
                gameState.playerName = 'NONAME';
                this.playerNameText.setText(gameState.playerName);
                
                // 位置を再調整
                this.editIcon.x = this.playerNameText.x + this.playerNameText.width / 2 + 20;
                
                // localStorageから削除（デフォルト値に戻す）
                localStorage.removeItem('playerName');
                return;
            }
            
            // 通常の入力処理
            // 名前を更新（15文字に制限）
            gameState.playerName = newName.trim().substring(0, 15);
            this.playerNameText.setText(gameState.playerName);
            
            // 位置を再調整
            this.editIcon.x = this.playerNameText.x + this.playerNameText.width / 2 + 20;
            
            // localStorageに保存
            localStorage.setItem('playerName', gameState.playerName);
        };
        
        this.playerNameText.on('pointerdown', editName);
        this.editIcon.on('pointerdown', editName);
    }
    
    /**
     * 設定ボタンを作成する
     */
    createSettingButton() {
        // 右上に設定ボタンを配置
        const margin = 20;
        
        this.settingButton = this.add.text(
            this.game.config.width - margin,
            margin,
            '⚙️',
            {
                fontSize: '48px',
                fontFamily: 'DotGothic16'
            }
        );
        this.settingButton.setOrigin(1, 0);
        this.settingButton.setInteractive();
        this.settingButton.setDepth(20);
        
        // クリックイベント
        this.settingButton.on('pointerdown', () => {
            this.scene.start('SettingScene');
        });
    }
    
    /**
     * レンガの背景を作成する
     */
    createBrickBackground() {
        // 画面サイズを取得
        const width = this.game.config.width;
        const height = this.game.config.height;
        
        // TileSpriteとして背景を作成（画面より大きめに）
        this.brickBackground = this.add.tileSprite(
            width / 2,    // x位置（中央）
            height / 2,   // y位置（中央）
            width + 100,  // 幅（画面より少し大きく）
            height + 100, // 高さ（画面より少し大きく）
            'brick'       // テクスチャキー
        );
        
        // 背景を最背面に配置
        this.brickBackground.setDepth(-100);
        
        // 背景のスライドアニメーション
        this.tweens.add({
            targets: this.brickBackground,
            tilePositionX: { from: 0, to: 100 },
            tilePositionY: { from: 0, to: 100 },
            ease: 'Linear',
            duration: 20000,
            repeat: -1
        });
    }
    
    /**
     * タイトルテキストを作成する
     */
    createTitleText() {
        this.titleText = this.add.text(
            this.game.config.width / 2,
            this.game.config.height / 6, // 1/4から1/6に変更して上に移動
            'Pendulumaster',
            {
                fontSize: '48px',
                fontStyle: 'bold',
                fontFamily: 'DotGothic16',
                fill: '#ffffff',
                stroke: '#000000',
                strokeThickness: 6
            }
        );
        this.titleText.setOrigin(0.5);
        
        // タイトルのアニメーション
        this.tweens.add({
            targets: this.titleText,
            y: this.titleText.y - 10,
            duration: 1500,
            ease: 'Sine.easeInOut',
            yoyo: true,
            repeat: -1
        });
    }
    
    /**
     * スタートボタンを作成する
     */
    createStartButton() {
        this.startButton = this.uiManager.createButton(
            this.game.config.height / 3 + 80, // もう少し下に移動
            'START',
            {
                backgroundColor: '#4CAF50',
                hoverColor: '#45a049',
                fontSize: '42px'
            },
            () => {
                // GameSceneに遷移
                this.scene.start('GameScene');
            }
        );
    }

    /**
     * BGMボタンを作成する
     */
    createBgmButton() {
        this.bgmButton = this.uiManager.createButton(
            this.game.config.height / 3 + 190, // スタートボタンとの間隔を調整
            gameState.bgmEnabled ? 'BGM: ON' : 'BGM: OFF',
            {
                backgroundColor: gameState.bgmEnabled ? '#4CAF50' : '#f44336',
                hoverColor: gameState.bgmEnabled ? '#45a049' : '#d32f2f',
                fontSize: '42px'
            },
            () => {
                gameState.bgmEnabled = !gameState.bgmEnabled;
                // localStorageに保存
                localStorage.setItem('bgmEnabled', gameState.bgmEnabled);
                this.bgmButton.setText(gameState.bgmEnabled ? 'BGM: ON' : 'BGM: OFF');
                this.bgmButton.setStyle({
                    backgroundColor: gameState.bgmEnabled ? '#4CAF50' : '#f44336'
                });
            }
        );
    }

    /**
     * ランキングボタンを作成する
     */
    createRankingButton() {
        this.rankingButton = this.uiManager.createButton(
            this.game.config.height / 3 + 300, // BGMボタンとの間隔を調整
            'RANKING',
            {
                backgroundColor: '#FF9800', // オレンジ色
                hoverColor: '#F57C00',
                fontSize: '42px'
            },
            () => {
                // 同じウィンドウでranking.htmlを開く（iOSのポップアップブロック対策）
                window.location.href = './ranking.html';
            }
        );
    }

    /**
     * ABOUTボタンを作成する
     */
    createAboutButton() {
        this.aboutButton = this.uiManager.createButton(
            this.game.config.height / 3 + 410, // ランキングボタンとの間隔を調整
            'ABOUT',
            {
                backgroundColor: '#2196F3',
                hoverColor: '#1976D2',
                fontSize: '42px'
            },
            () => {
                // 同じウィンドウでabout.htmlを開く（iOSのポップアップブロック対策）
                window.location.href = './about.html';
            }
        );
    }
    
    update() {
        // 必要に応じて更新処理を追加
    }
}
